import business from '../../src/Images/events-pictures/business.jpg'
import art from '../../src/Images/events-pictures/flowers.jpg';
import sport from '../../src/Images/events-pictures/sport.jpg'
import conference from '../../src/Images/events-pictures/conference.jpg';
import music from '../../src/Images/events-pictures/music.jpg';
import workshop from '../../src/Images/events-pictures/workshop.jpg'

const avatarImages = {
    business: business,
    art: art,
    sport: sport,
    conference: conference,
    music: music,
    workshop: workshop,
};

export default avatarImages;